import { useEffect, useState } from "react";
import { useLanguage } from "../lib/i18n";
import { Logo } from "./Logo";

export function Navbar() {
  const { lang, toggle, t } = useLanguage();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: t.nav.services, id: "#services" },
    { label: t.nav.gallery, id: "#gallery" },
    { label: t.nav.warranty, id: "#warranty" },
    { label: t.nav.faq, id: "#faq" },
    { label: t.nav.contact, id: "#contact" },
  ];

  return (
    <header
      className={`fixed left-0 top-0 z-[9995] w-full transition-colors duration-500 ${
        scrolled ? "bg-[#0F1115]/80 backdrop-blur-xl border-b border-white/5" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-[1600px] items-center justify-between px-6 py-4 md:px-12">
        <a href="#top" data-cursor data-cursor-label="ÜST" aria-label="HARSPRO">
          <Logo />
        </a>

        <div className="hidden items-center gap-8 lg:flex">
          {links.map((l) => (
            <a
              key={l.id}
              href={l.id}
              data-cursor
              className="font-inter text-sm text-hars-muted transition-colors duration-300 hover:text-white"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-4">
          <button
            onClick={toggle}
            data-cursor
            data-testid="lang-toggle"
            aria-label="Change language"
            className="flex items-center gap-1 font-inter text-xs font-semibold tracking-widest"
          >
            <span className={lang === "tr" ? "text-hars-orange" : "text-hars-muted"}>TR</span>
            <span className="text-hars-muted/40">/</span>
            <span className={lang === "en" ? "text-hars-orange" : "text-hars-muted"}>EN</span>
          </button>
          <a
            href="#contact"
            data-cursor
            data-cursor-label="RANDEVU"
            data-testid="nav-cta"
            className="hidden rounded-full bg-hars-orange px-5 py-2.5 font-inter text-sm font-semibold text-white transition-transform duration-300 hover:scale-105 md:block"
          >
            {t.nav.cta}
          </a>
        </div>
      </nav>
    </header>
  );
}
